import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Graduation } from '../graduation-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<Graduation, unknown>[] = [
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture' }),
		buildColumn(util, 'Text', row => row.entrepreneurs, { header: 'Entrepreneurs' }),
		buildColumn(util, 'Text', row => row.status, { header: 'Status', group: 'desc', width: 100 }),
		buildColumn(util, 'Percent', row => row.totalScore, { header: 'Award Score', sort: 'desc' }),
		buildColumn(util, 'Text', row => row.issues, { header: 'Issues' }),
		buildColumn(util, 'Percent', row => row.eLearningScore, { header: 'eLearning Score' }),
		buildColumn(util, 'Percent', row => row.minELearningScore, { header: 'Min eLearning Score', hidden: true }),
		buildColumn(util, 'Percent', row => row.attendanceScore, { header: 'Attendance Score' }),
		buildColumn(util, 'Percent', row => row.minAttendanceScore, { header: 'Min Attendance Score', hidden: true }),
		buildColumn(util, 'Percent', row => row.surveyScore, { header: 'Survey Score' }),
		buildColumn(util, 'Percent', row => row.minSurveyScore, { header: 'Min Survey Score', hidden: true }),
		buildColumn(util, 'Percent', row => row.workbookScore, { header: 'Workbook Score', hidden: true }),
		// buildColumn(util, 'Percent', row => row.roadmapScore, { header: 'Roadmap Score' }),
		buildColumn(util, 'Percent', row => row.finalPresentationScore, { header: 'Final Presentation Score' }),
	];


	return columns;

}